<template>
  <div class="box-home">
    <nav-bar class="v-nav-mobile" />
    <div class="hide-on-med-and-down box-drawer">
      <drawer-navigation />
    </div>
    <div class="box-content">
      <div class="container">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home"
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables.scss";

.container {
  width: 90%;
}

.box-home {
  display: flex;
  height: 100%;
  width: 100%;
}

.box-content {
  width: 100%;
  display: flex;
  margin-top: 64px;
  margin-left: 200px;
  @media #{$medium-and-down} {
    margin-left: 0;
  }
}

.box-drawer {
  width: 200px;
  position: fixed;
  background-color: $primary-color;
  height: 100%;
  margin-top: 64px;
}
</style>
